function CompleteTheLookCard(props) {
  const [productVariants, setProductVariants] = React.useState([]);
  const [prod, setProd] = React.useState([]);
  const [loaded, setLoaded] = React.useState(false);
  const [t, setT] = React.useState('');
  const [prodT, setProdT] = React.useState("");
  const [disabled, setDisabled] = React.useState(false);

  // const disabled = props.disabled;

  function addToCart(id) {
    // console.log('AddToCart activated')

    if (props.item.__queryID) {
      try {
        aa('getUserToken', null, (err, userToken) => {
          if (err) {
            console.error(err);
            return;
          }
          // window.aa('viewedObjectIDs', {
          //   'eventType': 'view',
          //   'eventName': 'Test View Event',
          //   'index': 'TestIndex',
          //   'objectIDs': ['test-object']
          // })
          aa('convertedObjectIDsAfterSearch', {
            userToken: userToken,
            index: INDEX_NAME,
            eventName: "convertedObjectIDsAfterSearch",
            queryID: props.item.__queryID,
            objectIDs: [props.item.objectID]
          });
        });
      } catch (e) {
        console.log(e);
      }
    }
    let formData = {
      'items': []
    };
    formData.items.push({
      id: id,
      quantity: 1
    });
    // console.log('HERE', id)
    setProdT(id);
    // console.log('ProdId setted to: ', id)
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then(response => response.json()).then(data => {
      // document.querySelector('.js-drawer-open-cart').click();
      formData.items = [];

      // let newCart = new theme.CartDrawer();
      // newCart.buildCart(data, true, 'CartDrawer');
    }).catch(error => {
      console.error('Error:', error);
    });
  }
  React.useEffect(() => {
    // console.log('CompleteThe Look card PROPS: ', props)

    const endpoint = 'https://tlfapparel.myshopify.com/api/2023-01/graphql.json';
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Shopify-Storefront-Access-Token': '239f5284842448954ceaeb9e81a967b4'
    });
    const getShopifyCollectionByHandle = async () => {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          query: query()
        })
      });
      const Collection = await response.json();
      // console.log('REPSONSE: ', Collection)
      if (Collection.data.node) {
        props.counter && props.counter();
        setProd(Collection.data.node);
        setT(Collection.data.node.images.edges[0].node.transformedSrc);
        setProductVariants(Collection.data.node.variants.edges);
        setLoaded(true);
      }
      Collection.data.node.tags && setDisabled(disableQuickBuy(Collection.data.node.tags));
    };
    const query = () => `{
    node(id: "${props.item.id}") {
      id
      ... on Product {
        images(first: 2) {
          edges {
            node {
              transformedSrc(maxWidth: 560, maxHeight: 854)
            }
          }
        }
        handle
        tags
        title
        variants(first: 9) {
          edges {
            node {
              id
              compareAtPriceV2{
                amount
              }
              priceV2 {
                amount
              }
              quantityAvailable
              selectedOptions{
                value
              }
            }
          }
        }
      }
    }
  }`;
    getShopifyCollectionByHandle();
  }, [props.item.id]);
  function disableQuickBuy(tags) {
    switch (true) {
      case tags.includes("promo:COMING SOON"):
        return true;
      case tags.includes("promo:APP EXCLUSIVE"):
        return true;
      default:
        return false;
    }
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, loaded && /*#__PURE__*/React.createElement("div", {
    className: "completeTheLookCard"
  }, /*#__PURE__*/React.createElement("div", {
    className: "completeTheLookProductDetails"
  }, /*#__PURE__*/React.createElement("div", {
    className: "productInformationForCTL"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: "productTitleCTL"
  }, prod.title), prod.variants && /*#__PURE__*/React.createElement("div", {
    className: "productPriceContainer"
  }, prod.variants.edges[0].node.compareAtPriceV2.amount != prod.variants.edges[0].node.priceV2.amount ? /*#__PURE__*/React.createElement("div", {
    className: "tlf-product-price"
  }, /*#__PURE__*/React.createElement("span", {
    className: "tlf-product-price-discounted"
  }, "$", parseFloat(prod.variants.edges[0].node.priceV2.amount).toFixed(2)), /*#__PURE__*/React.createElement("span", {
    className: "productPrice lineThrough"
  }, "$", parseFloat(prod.variants.edges[0].node.compareAtPriceV2.amount).toFixed(2))) : /*#__PURE__*/React.createElement("div", {
    className: "tlf-product-price"
  }, "$", parseFloat(prod.variants.edges[0].node.priceV2.amount).toFixed(2)))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: "quickAdd quickAddCTL"
  }, "QUICK ADD TO BAG"), disabled ? /*#__PURE__*/React.createElement("a", {
    href: `/products/${prod.handle}`,
    className: "variantButton variantButtonCTL"
  }, /*#__PURE__*/React.createElement("p", null, "View")) : /*#__PURE__*/React.createElement("div", {
    className: "variants variantsCTL"
  }, productVariants && productVariants.map((variant, index) => /*#__PURE__*/React.createElement("div", {
    className: `variantButton variantButtonCTL ${variant.node.quantityAvailable > 1 ? "" : "disabledVariant"}`,
    onClick: () => {
      if (variant.node.quantityAvailable > 1) addToCart(variant.node.id.replace("gid://shopify/ProductVariant/", ""));
    },
    key: index
  }, /*#__PURE__*/React.createElement("h1", null, variant.node.selectedOptions[1] && variant.node.selectedOptions[1].value))), productVariants.length == 5 || productVariants.length == 2 ? /*#__PURE__*/React.createElement("a", {
    href: `/products/${prod.handle}`,
    className: "variantButton variantButtonCTL"
  }, /*#__PURE__*/React.createElement("p", null, "View")) : null))), /*#__PURE__*/React.createElement("a", {
    href: `/products/${prod.handle}`,
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React.createElement("img", {
    className: "productImageForCTL",
    alt: "Product image",
    src: t
  })))));
}
